import { connect } from 'react-redux'

import {PANTALLA_PORTADA_ID, PANTALLA_ANTERIOR_ID, selectors, actions } from 'ibook-api'
import Pantalla from './pantalla'

const mapStateToProps = (state, ownProps) => {
    const configFlashcards =  selectors.getConfigIndice(state, 'Flashcards')
    return {
        ...configFlashcards,
        ...selectors.getPantallaProps(state)
    }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
    onContinuar: (libroId, numPagina, numZona, fcs) => {
        const params = fcs.join(';')
        dispatch(actions.ejecutarFuncion(libroId, numPagina, numZona, 'abrirVisorFC', params))
    },
    onTip: (libroId, numPagina, numZona) => dispatch(actions.zona(libroId, numPagina, numZona)),
    onImprimir: (fcs, texto) => {
        const url = encodeURI(`printFC.html?fcs=${fcs.join(',')}&texto=${ texto }`)
        window.open(url, '_blank')
    },
    onAtras: () => dispatch(actions.pantalla(PANTALLA_ANTERIOR_ID)),    
    onVolverAMenu: () => dispatch(actions.pantalla(PANTALLA_PORTADA_ID, {})) // Nota: esto podria ser un PANTALLA_ANTERIOR_ID dos veces    
})

const PantallaSeleccionarFlashcards = connect(
    mapStateToProps, 
    mapDispatchToProps
)(Pantalla)

export default PantallaSeleccionarFlashcards